import moment from 'moment';
import type { CurrentInventoryPackScopeQueryParams } from 'features/scratchers/utils/currentInventoryPackScopeQuery';

export const buildCurrentInventoryPackScopeSearchParams = (
  params: CurrentInventoryPackScopeQueryParams
) => {
  const searchParams = new URLSearchParams();
  searchParams.set('metric', params.metric);
  if (params.report_date) {
    searchParams.set('report_date', moment(params.report_date).format('YYYY-MM-DD'));
  }
  if (params.start_date) {
    searchParams.set('start_date', moment(params.start_date).format('YYYY-MM-DD'));
  }
  if (params.end_date) {
    searchParams.set('end_date', moment(params.end_date).format('YYYY-MM-DD'));
  }
  if (params.audit_id) {
    searchParams.set('audit_id', params.audit_id);
  }

  return searchParams;
};

export const buildCurrentInventoryStatusPath = (
  storeId: string,
  params: CurrentInventoryPackScopeQueryParams
) => `/store/${storeId}/scratchers/current-inventory-status?${buildCurrentInventoryPackScopeSearchParams(params).toString()}`;
